import { TFunction } from 'i18next';

export interface IStep {
  label: string;
  route: string;
  number: number;
}

export const stepRoutes: string[] = ['/feature', '/details'];

export const getSteps = (t: TFunction): IStep[] => [
  { label: t('newCampaigns.steps.step1'), route: stepRoutes[0], number: 1 },
  { label: t('newCampaigns.steps.step2'), route: stepRoutes[1], number: 2 },
];
